module.exports = __webpack_public_path__ + "img/agricultura-outline.c2afe2ca.svg";